import React from "react";
import { Container } from "react-bootstrap";

export default function Terms() {
  return (
    <Container style={{ paddingTop: "40px", paddingBottom: "40px" }}>
      <h1>Terms of Service</h1>
      <h5><strong>Effective Date:</strong> June 2024</h5>
      <h5><strong>Website:</strong> https://www.jsonhelper.io</h5>
      <br /><hr /><br />
      <h5><strong>1. Acceptance of Terms</strong></h5>
      <br />
      <p>
        By accessing or using JSONHelper.io (“the Service”), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.
      </p>
      <br /><hr /><br />
      <h5><strong>2. Description of Service</strong></h5>
      <br />
      <p>
        JSONHelper.io provides a browser-based tool that converts JSON data into a visual, human-readable format.
      </p>
      <p>All JSON processing occurs locally in your browser. We do not store, transmit, or retain the JSON data you paste into the tool.
       </p>

<br /><hr /><br />
      <h5><strong>3. Use of the Service</strong></h5>
      <br />
        <p>You agree to use the Service only for lawful purposes.
</p>
<p>You may not:</p>
<ul>
    <li>Use the Service to process unlawful or harmful content</li>
    <li>Attempt to interfere with the Service’s functionality</li>
    <li>Attempt to reverse engineer or exploit the platform</li>
    <li>Use automated systems (bots/scrapers) in a way that disrupts the Service</li>
</ul>
<br /><hr /><br />      <h5><strong>4. No Warranty</strong></h5>
      <br />
      <p> The Service is provided “as is” and "as available"without any warranties of any kind, either express or implied. </p>
       <p>We make no guarantees that:</p>
        <ul>
            <li>The Service will be uninterrupted or error-free</li>
            <li>The output will be free from bugs</li>
            <li>The Service will meet your specific requirements</li>
        </ul>
        <p>Use of the Service is at your own risk.</p>

<br /><hr /><br />
        <h5><strong>5. Limitation of Liability</strong></h5>
        <br />
        <p>To the maximum extent permitted by law, JSONHelper.io and its operators shall not be liable for:</p>
        <ul>
            <li>Any direct, indirect, incidental, special, or consequential damages arising out of or in connection with your use of the Service</li>
            <li>Data loss</li>
            <li>Business interruption</li>
            <li>Indirect or consequential damages</li>
            <li>Any issues arising from use of the Service</li>
        </ul>
        <p>You are responsible for maintaining backups of your own data.</p>
        <br /><hr /><br />
        <h5><strong>6. Intellectual Property</strong></h5>

        <p>All website content, design, branding, and software code (excluding user-submitted JSON) are the property of JSONHelper.io and may not be copied or redistributed without permission.</p>

        <p>You retain full ownership of any JSON data you input into the tool.</p>
        <br /><hr /><br />
        <h5><strong>7. Third-Party Services</strong></h5>

        <p>We may use third-party services including:</p>
        <ul>
            <li>Analytics providers</li>
            <li>Hosting providers</li>
            <li>Advertising partners (such as Google AdSense)</li>
        </ul>

<p>These services may use cookies or similar technologies as described in our Privacy Policy.</p>

<br /><hr /><br />
        <h5><strong>8. Privacy</strong></h5>

        <p>Your use of the Service is also governed by our Privacy Policy.</p>

        <p>We do not store JSON input data. However, analytics and advertising partners may collect anonymous usage data.</p>

<br /><hr /><br />
        <h5><strong>9. Modifications</strong></h5>

        <p>We reserve the right to modify these Terms at any time. Continued use of the Service after changes are posted constitutes acceptance of the revised Terms.</p>
    
    <br /><hr /><br />
    <h5><strong>10. Contact Information</strong></h5>

    <p>If you have questions about these Terms, please contact:</p>

    <p>info@uvgrade.com</p>
    
    </Container>
  );
}